import Fondo from "../assets/persona.png";
import { motion } from "framer-motion";

const QuienesSomos = () => {
    return (
        <div className="relative bg-[#028299] w-full h-auto md:h-[90vh] pt-[20vh] grid grid-cols-1 md:grid-cols-2">
            {/* Onda SVG en el top */}
            <div className="absolute top-0 left-0 w-full overflow-hidden leading-none z-10">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1440 155"
                    preserveAspectRatio="none"
                    className="w-full h-[100px] md:h-[155px]"
                >
                    <path
                        d="M0,71.7169637 C390.59867,-37.9017759 919.556541,-69.8103913 1440,70.6533432 C1440,83 1440,134.065337 1440,155 C1422.97118,155 942.971175,155 0,155 C0,107 0,79.2389879 0,71.7169637 Z"
                        fill="#FFFFFF"
                        transform="translate(720, 66) scale(1, -1) translate(-720, -66)"
                    />
                </svg>
            </div>

            {/* Texto */}
            <motion.div
                className="w-full h-full flex flex-col justify-center text-left px-4 md:px-10 gap-4 text-white relative z-20"
                initial={{ opacity: 0, x: 100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <h1 className="text-4xl font-bold">Quienes Somos</h1>
                <p className="text-lg text-justify">
                    Somos una asociación civil sin fines de lucro especialistas en Derecho de Autor,
                    enfocados en la protección de autores, empresas editoriales, organismos de radiodifusión,
                    productoras cinematográficas y fonográficas, artistas, influencers y, en general,
                    de todo creador de contenidos y de toda empresa de base cultural,
                    conforme a la Ley Federal del Derecho de Autor y los Tratados Internacionales aplicables.
                </p>
                <a
                    href="https://www.gdamagazine.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-center p-4 w-64 bg-white text-teal-500 text-lg font-bold rounded-full"
                >
                    Conoce nuestro trabajo
                </a>
            </motion.div>

            {/* Imagen */}
            <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="w-full h-[55vh] md:h-full bg-contain bg-top bg-no-repeat flex items-center justify-start relative z-20"
                style={{ backgroundImage: `url(${Fondo})` }}
            />
        </div>
    );
};

export default QuienesSomos;
